import { Controller } from "stimulus"
import axios from 'axios'

export default class extends Controller {
  static targets = ["convention", "rateSchedule"]

  connect() {
    if (this.hasConventionTarget && this.hasRateScheduleTarget) {
      this.updateRateSchedules()
    }
  }

  conventionChanged() {
    if (this.hasConventionTarget && this.hasRateScheduleTarget) {
      this.updateRateSchedules()
    }
  }

  async updateRateSchedules() {
    const conventionId = this.conventionTarget.value
    const rateScheduleTarget = this.rateScheduleTarget
    
    if (!conventionId) {
      // Clear rate schedules if no convention selected
      rateScheduleTarget.innerHTML = '<option value="">Select a convention first</option>'
      return
    }

    try {
      // Fetch rate schedules for the selected convention
      const response = await axios.get(`/api/v1/exhibitor/rate_schedules?convention_id=${conventionId}`)
      const rateSchedules = response.data.data['exhibitor/rate_schedules'] || []
      
      // Build the options
      let options = '<option value="">None Chosen - Default will be used</option>'
      
      rateSchedules.forEach(rate => {
        const selected = rate.name === 'Price Lock' ? 'selected' : ''
        options += `<option value="${rate.id}" ${selected}>${rate.name}</option>`
      })
      
      rateScheduleTarget.innerHTML = options
    } catch (error) {
      console.error('Error fetching rate schedules:', error)
      rateScheduleTarget.innerHTML = '<option value="">Error loading rate schedules</option>'
    }
  }
} 